import { GetComisionesPorPeriodo } from "../../../reducers/comisionCoordinadorAdministrativo";

export interface ReporteCoordinadorAdministrativoStore
  extends GetComisionesPorPeriodo {}

export const reporteCoordinadorAdministrativoStore: (
  state: any
) => ReporteCoordinadorAdministrativoStore = (state: any) => ({
  comisiones: state.comisionCoordinadorAdministrativo.comisiones,
  gettingComisiones: state.comisionCoordinadorAdministrativo.gettingComisiones,
  gettingComisionesError:
    state.comisionCoordinadorAdministrativo.gettingComisionesError
});
